/**
 *
 * Headline text animates vertically upwards line by line (example: norda run)
 *
 */


class AnimateText {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.initIntersectionObserver();
    }

    initIntersectionObserver() {
        const header = document.querySelector('.page-header');
        const { height: headerHeight } = header.getBoundingClientRect();

        const options = {
            root: null,
            threshold: 0.3,
            rootMargin: `${headerHeight * -1}px 0px 0px 0px`,
        };

        const animationObserver = new IntersectionObserver((entries, self) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                    self.unobserve(this.elem);
                } else {
                    entry.target.classList.remove('in-view');
                }
            });
        }, options);

        animationObserver.observe(this.elem);
    }
}

export default AnimateText;
